import { random, round2 } from "../helpers/helpers";

export const generate_busbar_month_chart_demo = ({ year, month }) => {
    const now = new Date();
    const today = now.getDate();

    const daysInMonth = new Date(year, month, 0).getDate();
    const daily_energy_data = [];

    for (let day = 1; day <= daysInMonth; day++) {
        // ❌ future days
        if (
            year === now.getFullYear() &&
            month === now.getMonth() + 1 &&
            day > today
        ) {
            break;
        }

        daily_energy_data.push({
            day,

            avg_temp_b: round2(random(25.0, 26.5)).toFixed(2),
            avg_temp_r: round2(random(24.8, 26.2)).toFixed(2),
            avg_temp_y: round2(random(24.8, 26.2)).toFixed(2),

            max_temp_b: round2(random(26.2, 27.5)).toFixed(2),
            max_temp_r: round2(random(26.0, 27.2)).toFixed(2),
            max_temp_y: round2(random(26.0, 27.2)).toFixed(2),

            min_temp_b: round2(random(24.3, 25.0)).toFixed(2),
            min_temp_r: round2(random(24.0, 24.8)).toFixed(2),
            min_temp_y: round2(random(24.0, 24.8)).toFixed(2),
        });
    }

    return {
        year,
        month,
        daily_energy_data,
    };
};